import React, { useState } from "react";

import { LocalDateTime } from "@js-joda/core";
import { GanttProps } from "components/ComponentType";
import CalendarWrapper from "components/basic/calendar-wrapper/CalendarWrapper";
import ProductTemplateTable from "components/dashboard/product-template-table/ProductTemplateTable";
import useTimeState from "hooks/dashboard/useTimeState";
import { TabPanel, TabView } from "primereact/tabview";
import { T } from "services/lang/LanguageService";
import { SelectButton, SelectButtonChangeEvent } from "primereact/selectbutton";
import { addToDate } from "utils/time-utils";
import GanttChartWrapper from "./components/GanttChartWrapper";
import { offsetOptions } from "../utils";

const Gantt = (props: GanttProps) => {
  const [filter, setFilter] = useState<string | null>(null);
  const [selectedTimeOffset, setSelectedTimeOffset] = useState<string | undefined>(undefined);

  const timeState = useTimeState({
    from: props.from ?? LocalDateTime.now().minusDays(7).toString(),
    to: props.to ?? LocalDateTime.now().toString(),
  });

  const onSelectButtonChange = (e: SelectButtonChangeEvent) => {
    setSelectedTimeOffset(e.value);
    timeState.setFrom(addToDate(timeState.to ?? new Date(), -1, e.value));
  };

  return (
    <div className="flex flex-column gap-3 p-3">
      <div className="flex flex-row gap-3 align-items-end flex-wrap">
        <CalendarWrapper
          value={timeState.from}
          showTime
          onChange={date => timeState.setFrom(date)}
          dateFormat="yy-mm-dd"
        />
        <CalendarWrapper
          value={timeState.to}
          showTime
          onChange={date => timeState.setTo(date)}
          dateFormat="yy-mm-dd"
        />
        <div style={{ flexWrap: "nowrap", whiteSpace: "nowrap" }}>
          <SelectButton
            value={selectedTimeOffset}
            options={offsetOptions}
            onChange={onSelectButtonChange}
            className="select-button-class"
          />
        </div>
      </div>
      <TabView>
        <TabPanel header={T("word.chart")}>
          <GanttChartWrapper
            {...props}
            from={timeState.from?.toISOString()}
            to={timeState.to?.toISOString()}
            height={props.height}
            filter={filter}
          />
        </TabPanel>
        <TabPanel header={T("word.table")}>
          <ProductTemplateTable
            {...props}
            showTitle={false}
            hideDates
            from={timeState.from?.toISOString()}
            to={timeState.to?.toISOString()}
            filter={filter}
            onFilterChange={val =>
              setFilter(props.filter ? `${props.filter}${val && `;${val}`}` : val)
            }
          />
        </TabPanel>
      </TabView>
    </div>
  );
};

export default Gantt;
